export default __webpack_public_path__ + "static/media/ethee.9708b5e3.png";